import React from 'react';

import style from './contact.module.scss';

export const Contact = () => {
    return (
        <div className={style.contact}>
            <div className={style.contactTitle}>
                CONTACT INFORMATION <br />
            </div>

            <div className={style.contactAddress}>No.6 Jingyue Street, Xinhua district, Shijiazhuang, Hebei</div>

            <div className={style.contactPhone}>
                Phone: 86-15369357369 <br />
            </div>
        </div>
    );
};
